import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let LogController = {
    logUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/sas-log/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
}

export default LogController
